import { BlobServiceClient } from "@azure/storage-blob";

const containerName = "stockfile";
// const sasToken="sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2026-11-30T15:16:27Z&st=2025-11-29T07:01:27Z&spr=https,http&sig=jxTrP3P0txM1Q8qHPA%2FT4gfv1dQ63mR3noxUOTiMOws%3D"
const sasToken="sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2026-12-02T12:27:38Z&st=2025-12-02T04:12:38Z&spr=https,http&sig=%2Bsyz2GQC7VeG0BhRs%2BLu8ALq%2B6aliaKBLkP%2BdO4LcnE%3D"
const upload_azure_url = "https://inwardexcel.blob.core.windows.net/"

const uploadExcelToAzure = async ({ excelFile, blobName, directoryName }) => {
    try {
        // Create a BlobServiceClient using connection string
        const blobServiceClient = new BlobServiceClient(
            `${upload_azure_url}?${sasToken}`
        );

        // Get a reference to the container
        const containerClient = blobServiceClient.getContainerClient(containerName);

        // Get a block blob client for the target file path in Azure
        const blobPath = `${blobName}`;
        const blockBlobClient = containerClient.getBlockBlobClient(blobPath);

        // Determine content type based on file extension
        const fileExtension = excelFile.name.split('.').pop().toLowerCase();
        let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; // Default for .xlsx
        
        if (fileExtension === 'xls' || fileExtension === 'xlsx') {
            contentType = 'application/vnd.ms-excel';
        }
        
        // Upload options
        const options = {
            blobHTTPHeaders: {
                blobContentType: contentType,
            },
        };
        
        // Upload the Excel file to Azure
        const uploadResponse = await blockBlobClient.upload(excelFile, excelFile.size, options);
        // Check if the upload was successful
        if (!uploadResponse.errorCode) {
            return { success: true, url: blockBlobClient.url };
        }

        return { success: false, error: 'Upload failed' };
    } catch (error) {
        console.error("Error uploading Excel file to Azure", error);
        return { success: false, error: error.message };
    }
};

export default uploadExcelToAzure;

